<template>
  <div class="space-x-1">
    <UiButton
      id="header-user"
      variant="navigation"
      class="!px-2 xl:!px-4"
      :icon="IconProfile"
      icon-side="left"
      @click="userAction()"
    >
      <UiText class="hidden xl:block">
        {{ authStore.isLoggedIn ? (customerStore.customer?.firstname ?? '-') : $t('header.login') }}
      </UiText>
    </UiButton>
    <UiLink
      id="header-store-locator"
      to="/store-locator"
      :aria-label="$t('header.storeLocator')"
      @click="clickAction('store-locator')"
    >
      <UiIconButton
        id="header-store-locator"
        :icon="IconMapPin"
        class="!bg-primary-500 hover:!bg-primary-800 focus:!bg-primary-900 disabled:!bg-disabled-300"
      />
    </UiLink>
    <UiLink
      v-if="authStore.isLoggedIn"
      id="header-wishlist"
      to="/profile?tab=my-wishlist"
      @click="clickAction('wishlist')"
    >
      <UiIconButton
        id="header-wishlist"
        :icon="IconHeart"
        class="!bg-primary-500 hover:!bg-primary-800 focus:!bg-primary-900 disabled:!bg-disabled-300"
        :badge="wishlistStore.getWishlistItemsTotal > 0"
        :badge-content="wishlistStore.getWishlistItemsTotal.toString()"
      />
    </UiLink>
    <UiLink id="header-cart" to="/cart" @click="clickAction('cart')">
      <UiIconButton
        id="header-cart"
        :icon="IconCart"
        class="!bg-primary-500 hover:!bg-primary-800 focus:!bg-primary-900 disabled:!bg-disabled-300"
        :badge="cartStore.getCartItemsTotal > 0"
        :badge-content="cartStore.getCartItemsTotal.toString()"
      />
    </UiLink>
  </div>
</template>

<script setup lang="ts">
import { IconCart, IconHeart, IconMapPin, IconProfile } from '#components';

import { useAuthStore } from '~/stores/auth/authStore';
import { useCartStore } from '~/stores/cart/cartStore';
import { useCustomerStore } from '~/stores/customer/customerStore';
import { useWishlistStore } from '~/stores/wishlist/wishlistStore';

const goTo = useGoTo();
const {
  proxy: { dataLayer },
} = useScriptGoogleTagManager();

const customerStore = useCustomerStore();
const cartStore = useCartStore();
const authStore = useAuthStore();
const wishlistStore = useWishlistStore();

const userAction = (): void => {
  goTo(authStore.isLoggedIn ? '/profile' : '/login');
  clickAction(authStore.isLoggedIn ? 'profile' : 'login');
};

const clickAction = (action: string): void => {
  dataLayer.push({
    component: 'header',
    event: 'button_click',
    value: action,
  });
};
</script>
